import { createFileRoute } from '@tanstack/react-router';
import { CounterpartForm } from '@/pages/registry/counterparts/form/counterpart-form';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';

export const Route = createFileRoute(
  '/protected/_layout/registry/_layout/counterparts/$id'
)({
  component: () => {
    const { id } = Route.useParams();
    // Una controparte nuova riparte da zero: documento aperto, filtri,
    // espansioni e dialoghi della precedente non le appartengono.
    return (
      <CounterpartForm key={id} id={id} returnUrl={`${PROTECTED}${REGISTRY}`} />
    );
  },
});
